<sui-input
  class="ag-floating-filter-input"
  [ngModel]="text"
  (ngModelChange)="onInput($event)"
  [readonly]="readonly"
  (click)="readonly && openPopup()"
></sui-input>
